import {isFeatureEnabled} from '@github-ui/feature-flags'

/**
 * Gates the new repo-issues sidebar/header layout on the
 * `repo_issues_sidebar_layout` (current_user-scoped) flag.
 */
// eslint-disable-next-line @eslint-react/no-unnecessary-use-prefix -- keeps the stable hook-style name used across issues pages; called in component bodies.
export function useRepoIssuesSidebarLayoutEnabled(): boolean {
  return isFeatureEnabled('repo_issues_sidebar_layout')
}
